// Define backgroundVideo as a global object if it doesn't exist
window.backgroundVideo = window.backgroundVideo || {
  initialized: false,
  init: function(videoClass = '.covervid-video') {
    if (this.initialized) return;
    this.initialized = true;

    const videos = document.querySelectorAll(videoClass);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadCoverVid(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: '100px', threshold: 0.5 }
      );

      videos.forEach((video) => observer.observe(video));
    } else {
      videos.forEach((video) => this.loadCoverVid(video));
    }
  },

  loadCoverVid: function(video) {
    if (video.dataset.loaded) return;
    video.dataset.loaded = 'true';

    const sources = video.querySelectorAll('source');
    sources.forEach((source) => {
      const sourceFile = source.getAttribute('data-src');
      source.setAttribute('src', sourceFile);
    });
    
    video.load();
    if (video.play) {
      video.play().catch((error) => {
        console.warn('Auto-play was prevented:', error);
      });
    }
  }
};

// Function to initialize or reinitialize the background video functionality
function initBackgroundVideo() {
  backgroundVideo.initialized = false;
  backgroundVideo.init();
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initBackgroundVideo);

// Reinitialize on Shopify theme editor events
document.addEventListener('shopify:section:load', initBackgroundVideo);
document.addEventListener('shopify:section:select', initBackgroundVideo);

// Make initBackgroundVideo available globally for manual calls if needed
window.initBackgroundVideo = initBackgroundVideo;